import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import cutIcon from "../../assets/icons/x-circle.svg";
import plus from "../../assets/icons/Plus.svg";
import AppDatePicker from "../Common/AppDatePicker";
import moment from "moment";
import bin from "../../assets/icons/Bin.svg";

const InvoiceSpace = ({
  invoice,
  setInvoice,
  date,
  setDate,
  id,
  setId,
  amount,
  setAmount,
  dueDate,
  setDueDate,
  VAT,
  setVAT,
  description,
  setDescription,
  handleAdd,
  addInvoiceList,
  setAddInvoiceList,
  handleDelete,
  addInvoice,
  isUpdate,
  setIsUpdate,
  updateId,
  setUpdateId,
  setInvoiceStatusToFalse,
  dispatch,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <>
      <div className="add-invoice-container invisible">
        <div>
          <div className="invoice-top-cont">
            <p className="add-invoice-text">
              {/* ADD invoice */}
              {t("Add Invoice")}
            </p>
            <img
              src={cutIcon}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setInvoice(false);
                setIsUpdate(false);
                setId("");
                setDescription("");
                setAddInvoiceList([]);
                setAmount("");
                setDueDate("");
                setVAT("");
                setUpdateId("");
                dispatch(setInvoiceStatusToFalse());
              }}
            />
          </div>
          <div className="add-invoice-grid">
            <CssTextField
              value={date}
              // onChange={(e) => setDate(e.target.value)}
              label="Date"
              placeholder="dd.mm.yyyy"
              focused
              style={{ backgroundColor: "white" }}
            />
            <CssTextField
              value={id}
              onChange={(e) => setId(e.target.value)}
              label="ID"
              placeholder=""
              focused
              style={{ backgroundColor: "white" }}
            />
            <CssTextField
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              label="Description"
              placeholder=""
              focused
              style={{ backgroundColor: "white" }}
            />
            <CssTextField
              value={amount}
              type="number"
              onChange={(e) => setAmount(e.target.value)}
              label="Amount ex. VAT"
              placeholder="E 0,00"
              focused
              style={{ backgroundColor: "white" }}
            />
            <CssTextField
              value={VAT}
              type="number"
              onChange={(e) => setVAT(e.target.value)}
              label="VAT %"
              placeholder="21,00"
              focused
              style={{ backgroundColor: "white" }}
            />
            <div style={{ position: "relative" }}>
              <CssTextField
                label="Due Date"
                placeholder=""
                focused
                style={{ backgroundColor: "white" }}
              />
              <div className="add-invoice-date-div">
                <AppDatePicker
                  selected={dueDate}
                  dateFormat="dd/MM/yyyy"
                  onChange={setDueDate}
                  placeholderText="dd/mm/yyyy"
                />
              </div>
            </div>
            {!isUpdate && (
              <img
                src={plus}
                style={{ cursor: "pointer" }}
                onClick={handleAdd}
              />
            )}
          </div>
          {addInvoiceList?.map((invoice, index) => {
            return (
              <div className="add-invoice-grid" key={index}>
                <CssTextField
                  value={moment(new Date()).format("DD.MM.YYYY")}
                  //  onChange={(e) => setDate(e.target.value)}
                  label="Date"
                  placeholder="dd.mm.yyyy"
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <CssTextField
                  value={invoice?.invoicecode}
                  //  onChange={(e) => setId(e.target.value)}
                  label="ID"
                  placeholder=""
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <CssTextField
                  value={invoice?.description}
                  //  onChange={(e) => setDescription(e.target.value)}
                  label="Description"
                  placeholder=""
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <CssTextField
                  value={invoice?.totalexclusivebtw}
                  // onChange={(e) => setAmount(e.target.value)}
                  label="Amount ex. VAT"
                  placeholder="E 0,00"
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <CssTextField
                  value={invoice?.vaTpercent}
                  //  onChange={(e) => setVAT(e.target.value)}
                  label="VAT %"
                  placeholder="21,00"
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <CssTextField
                  value={moment(invoice?.dueDate).format("DD.MM.YYYY")}
                  //  onChange={(e) => setDueDate(e.target.value)}
                  label="Due Date"
                  placeholder="dd.mm.yyyy"
                  focused
                  style={{ backgroundColor: "white" }}
                />
                <img
                  src={bin}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(index)}
                />
              </div>
            );
          })}
        </div>
        <div style={{ textAlign: "center" }}>
          <button className="invoice-add-btn addProAdd" onClick={addInvoice}>
            {isUpdate ? "Change" : "Add"}
          </button>
        </div>
      </div>
    </>
  );
};

export default InvoiceSpace;

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#7E7E7E",
    fontFamily: "Manrope",
    fontSize: "clamp(14px,1.025vw,1.025vw)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#70707080",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#70707080",
    },
    "&:hover fieldset": {
      borderColor: "#70707080",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#70707080",
    },
    "& .MuiInputBase-input": {
      borderRadius: 16,
    },
  },
});
